import { render, staticRenderFns } from "./doctor-manage.vue?vue&type=template&id=8ef4245e&"
import script from "./doctor-manage.vue?vue&type=script&lang=js&"
export * from "./doctor-manage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports